import { DocumentType } from '../document/document-base.dto';

import { PersonalIdentifierType } from './types';

export const isPersonalIdentifierType = (type: string): type is PersonalIdentifierType =>
  Object.values(PersonalIdentifierType).includes(type as PersonalIdentifierType);

export type DocumentCategory = DocumentType.PRIVATE_DOCUMENTS | PersonalIdentifierType;
/**
 *  @deprecated Use entities/personalIdentifiers/hooks/useI18nValues.
 */
export const DocumentCategoryToText: Record<DocumentCategory, string> = {
  [PersonalIdentifierType.CITIZENSHIP_CERTIFICATE]:
    'documents:enums.docCategory.citizenshipCertificate',
  [DocumentType.PRIVATE_DOCUMENTS]: 'documents:enums.privateDoc',
  [PersonalIdentifierType.DRIVER_LICENSE]: 'documents:enums.docCategory.driverLicense',
  [PersonalIdentifierType.PASSPORT]: 'documents:enums.docCategory.passport',
  [PersonalIdentifierType.BIRTH_CERTIFICATE]: 'documents:enums.docCategory.birthCertificate',
  [PersonalIdentifierType.EDUCATION]: 'documents:enums.docCategory.education',
  [PersonalIdentifierType.FREE_BLOCK]: 'documents:enums.docCategory.freeBlock',
  [PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE]:
    'documents:enums.docCategory.internationalDriverLicense',
  [PersonalIdentifierType.MEDICAL_ID]: 'documents:enums.docCategory.medicalId',
  [PersonalIdentifierType.MILITARY_ID]: 'documents:enums.docCategory.militaryId',
  [PersonalIdentifierType.NATIONAL_ID]: 'documents:enums.docCategory.nationalId',
  [PersonalIdentifierType.RESIDENCE_PERMIT]: 'documents:enums.docCategory.residencePermit',
  [PersonalIdentifierType.SOCIAL_SECURITY]: 'documents:enums.docCategory.socialSecurity',
  [PersonalIdentifierType.SUBSTANCE]: 'documents:enums.docCategory.substance',
  [PersonalIdentifierType.TAX_ID]: 'documents:enums.docCategory.taxId',
};
